'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuBar = exports.Breadcrumbs = exports.ViewControllerMixin = undefined;

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec4, _class3, _class4;

exports.getSelectedView = getSelectedView;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _mixwith = require('mixwith');

var _baseComponent = require('base-component');

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _baseViewstore = require('base-viewstore');

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _autoclassDecorator = require('autoclass-decorator');

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var ViewControllerMixin = exports.ViewControllerMixin = (0, _mixwith.Mixin)(function (superclass) {
  var _dec, _dec2, _dec3, _desc, _value, _class, _descriptor;

  return _dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, (_class = function (_superclass) {
    (0, _inherits3.default)(_class, _superclass);

    function _class() {
      (0, _classCallCheck3.default)(this, _class);

      var _this = (0, _possibleConstructorReturn3.default)(this, (_class.__proto__ || (0, _getPrototypeOf2.default)(_class)).apply(this, arguments));

      _this.currentViewOptions = {};

      _initDefineProp(_this, '_currentView', _descriptor, _this);

      var trackBreadcrumbs = _this.trackBreadcrumbs !== false && _this.constructor.trackBreadcrumbs !== false;
      var addToBreadcrumbs = _this.addToBreadcrumbs !== false && _this.constructor.addToBreadcrumbs !== false;
      var providedLastCm = _this.props.lastCm;
      _this.insideEditor = _this.props.insideEditor;
      _this.isRoot = _this.props.hasOwnProperty('isRoot') ? _this.props.isRoot : !providedLastCm;

      if (trackBreadcrumbs) {
        _this.lastCm = providedLastCm || _mobx.observable.shallowArray([]);
        _this.viewBreadcrumbs = providedLastCm ? _this.props.viewBreadcrumbs : _mobx.observable.shallowArray([]);
        _this.viewBreadcrumbIndex = _this.viewBreadcrumbs.length;
        if (addToBreadcrumbs) {
          setTimeout(function () {
            // escape this render stack, otherwise get naughty error...
            _this.viewBreadcrumbs.push(_this);
            _this.viewBreadcrumbIndex = _this.viewBreadcrumbs.length;
            var lastViewCm = _this.contentModel || _this.props.contentModel;
            if (lastViewCm) _this.lastCm[0] = lastViewCm;
            if (!lastViewCm) debugger;
          }, 10);
        }
      }

      // setTimeout( () => {

      //   if( !this.viewMap && !Array.isArray( this.views ) ) throw new Error(" missing viewMap object, or views array")
      //   if( !this.viewMap && Array.isArray( this.views ) ){
      //     extendObservable( this, {
      //       get viewMap(){
      //         return this.views.reduce( (acc, item) => {
      //           acc[item.id] = item
      //           return acc;
      //         }, {})
      //       }
      //     })
      //   }
      // }, 10)
      return _this;
    }

    (0, _createClass3.default)(_class, [{
      key: 'selectView',
      value: function selectView(view) {
        var _this2 = this;

        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var editorViewStore = this.props.editorViewStore;

        var unregistered = void 0;
        if (typeof view === "string" && !!this.viewMap[view]) {
          this.currentViewOptions = opts;
          this._currentView !== view && setTimeout((0, _mobx.action)(function () {
            _this2._currentView = view;
          }), 10);
          this.clearView();
        } else if ((typeof view === 'undefined' ? 'undefined' : (0, _typeof3.default)(view)) === "object") {
          var registeredView = this.viewMap[view.id] || view.type && this.viewMap[view.type];
          if (!registeredView && view.getComponent) {
            unregistered = true;
            registeredView = (0, _extends3.default)({}, view, { Component: false, Editor: false, FullEditor: false });
          }
          if (!registeredView) throw new Error("invalid view!");

          if (view.onClick) return view.onClick(view, registeredView, opts);
          if (registeredView.onClick) return registeredView.onClick(view, registeredView, opts);
          this.currentViewOptions = opts;

          //capture supplied contentModel if is BaseContentModel (detect via _slots)
          if (view.slots) this.currentViewOptions.contentModel = view;

          if (unregistered) {
            setTimeout((0, _mobx.action)(function () {
              _this2._currentView = registeredView;
            }), 10);
          } else {
            this._currentView !== registeredView.id && setTimeout((0, _mobx.action)(function () {
              _this2._currentView = registeredView.id;
            }), 10);
          }
          this.clearView();
        } else {
          throw new Error("invalid view!");
        }
      }
    }, {
      key: 'clearView',
      value: function clearView(clearBreadcrumb) {
        var editorViewStore = this.props.editorViewStore;
        //recursive clear view
        // if(this.currentView && typeof this.currentView.clearView === "function"){
        //   debugger
        //   //does this ever actually happen?
        //   this.currentView.clearView();
        // } 

        this._currentView = null;
        if (clearBreadcrumb && this.viewBreadcrumbs && this.viewBreadcrumbs.length) {
          this.viewBreadcrumbs.splice(this.viewBreadcrumbIndex, this.viewBreadcrumbs.length - this.viewBreadcrumbIndex);
          if (this.viewBreadcrumbs.length) {
            var lastView = this.viewBreadcrumbs[this.viewBreadcrumbs.length - 1];
            var lastViewCm = lastView.contentModel || lastView.props.contentModel;
            if (lastViewCm) this.lastCm[0] = lastViewCm;
            if (!lastViewCm) debugger;
          }
        }
        if (editorViewStore && !(this.currentViewOptions && this.currentViewOptions.insideEditor)) editorViewStore.stopEditing();
      }
    }, {
      key: 'goBack',
      value: function goBack(e) {
        var _this3 = this;

        var editorViewStore = this.props.editorViewStore;

        if (this.lastCm) {
          var lastCm = this.lastCm[0];
          if (lastCm && lastCm.isDirty) /*|| (this.contentModel && this.contentModel.isDirty)*/{
              lastCm.handleUnsavedChanges(function () {
                return _this3.clearView(true);
              });
            } else {
            this.clearView(true); //clears Breadcrumbs
          }
        } else {
          this.clearView(true); //clears Breadcrumbs
        }
      }
    }, {
      key: 'currentView',
      get: function get() {
        var _props = this.props,
            dataModel = _props.dataModel,
            contentModel = _props.contentModel;
        var contentModelOverride = this.currentViewOptions.contentModel;

        var viewMap = this.viewMap || this.props.viewMap;
        var view = viewMap && this._currentView ? (0, _typeof3.default)(this._currentView) === "object" ? this._currentView : viewMap[this._currentView] : null;
        if (view) view.contentModel = contentModelOverride || view.contentModel;
        return view;
      }
    }, {
      key: 'SelectedView',
      get: function get() {
        // only want to listen to this.currentView changes in this computed.  everything else is computed by getSelectedView
        return !!this.currentView && getSelectedView.call(this, this.currentView);
      }
    }]);
    return _class;
  }(superclass), (_descriptor = _applyDecoratedDescriptor(_class.prototype, '_currentView', [_mobx.observable], {
    enumerable: true,
    initializer: function initializer() {
      return "";
    }
  }), _applyDecoratedDescriptor(_class.prototype, 'currentView', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'currentView'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'SelectedView', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'SelectedView'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectView', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'selectView'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'clearView', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'clearView'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'goBack', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'goBack'), _class.prototype)), _class);
});

var Breadcrumbs = exports.Breadcrumbs = (_dec4 = (0, _mobxReact.inject)("editorViewStore"), _dec4(_class3 = (0, _mobxReact.observer)(_class3 = function (_BaseComponent) {
  (0, _inherits3.default)(Breadcrumbs, _BaseComponent);

  function Breadcrumbs() {
    (0, _classCallCheck3.default)(this, Breadcrumbs);
    return (0, _possibleConstructorReturn3.default)(this, (Breadcrumbs.__proto__ || (0, _getPrototypeOf2.default)(Breadcrumbs)).apply(this, arguments));
  }

  (0, _createClass3.default)(Breadcrumbs, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          viewstores = _props2.viewstores,
          useDisplayName = _props2.useDisplayName,
          editorViewStore = _props2.editorViewStore;

      var insideEditor = viewstores && viewstores.length && viewstores[0].insideEditor;

      return !!viewstores.length ? _react2.default.createElement(
        'div',
        { className: 'breadcrumbs' },
        viewstores.map(function (viewstore, i, arr) {
          var goBack = viewstore.goBack,
              editItem = viewstore.editItem,
              viewItem = viewstore.viewItem;

          var contentModel = viewstore.contentModel || viewstore.props.contentModel;
          if (!contentModel) throw new Error("malformed viewstore... must have contentModel or props.contentModel");
          var crumb = void 0;
          if (i !== arr.length - 1) {
            crumb = _react2.default.createElement(
              'div',
              { key: contentModel.id + i, onClick: goBack, className: 'crumb' },
              _react2.default.createElement(
                'div',
                null,
                !!useDisplayName && (contentModel.displayName || contentModel.displayTitle) || contentModel.id
              ),
              _react2.default.createElement('span', null)
            );
          } else {
            crumb = _react2.default.createElement(
              'div',
              { key: contentModel.id + i, className: 'crumb-current' },
              !!editorViewStore && !insideEditor && !contentModel.readonly && _react2.default.createElement(
                'span',
                { style: { cursor: "pointer" }, onClick: function onClick(e) {
                    return editItem(contentModel);
                  } },
                '\u270E '
              ),
              !!editorViewStore && !insideEditor && contentModel.Component && _react2.default.createElement(
                'span',
                { style: { cursor: "pointer" }, onClick: function onClick(e) {
                    return viewItem(contentModel);
                  } },
                '\uD83D\uDD0E '
              ),
              !!useDisplayName && (contentModel.displayName || contentModel.displayTitle) || contentModel.id,
              viewstore.hasOwnProperty('selectedCollectionName') && _react2.default.createElement(
                'select',
                { value: viewstore.selectedCollectionName || viewstore.availableCollectionNames[0], disabled: viewstore.availableCollectionNames.length < 2, onChange: function onChange(e) {
                    return viewstore.setCollection(e.target.value);
                  } },
                viewstore.availableCollectionNames.map(function (n) {
                  return _react2.default.createElement(
                    'option',
                    { key: n },
                    n
                  );
                })
              )
            );
          }
          return viewstore.BreadcrumbComponent ? _react2.default.createElement(viewstore.BreadcrumbComponent, { key: contentModel.id + i, originalCrumb: crumb, contentModel: contentModel, isCurrent: true }) : crumb;
        })
      ) : null;
    }
  }]);
  return Breadcrumbs;
}(_baseComponent2.default)) || _class3) || _class3);

var MenuBar = exports.MenuBar = (0, _mobxReact.observer)(_class4 = function (_BaseComponent2) {
  (0, _inherits3.default)(MenuBar, _BaseComponent2);

  function MenuBar() {
    (0, _classCallCheck3.default)(this, MenuBar);
    return (0, _possibleConstructorReturn3.default)(this, (MenuBar.__proto__ || (0, _getPrototypeOf2.default)(MenuBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(MenuBar, [{
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          viewMap = _props3.viewMap,
          clickItem = _props3.clickItem,
          currentView = _props3.currentView,
          currentViewId = _props3.currentViewId;

      var displayItems = (0, _values2.default)(viewMap).filter(function (v) {
        return v.show || v.menu && v.menu.show;
      });
      return _react2.default.createElement(
        'div',
        { className: 'menu' },
        displayItems.map(function (view, index) {
          var iconClass = view.icon || view.contentModel && view.contentModel.icon || "";
          var menu = (0, _assign2.default)({ clickItem: clickItem }, view, view.menu);
          var itemStatus = currentViewId && menu.id === currentViewId || currentView && currentView.id === menu.id ? "active" : "inactive";
          return _react2.default.createElement(
            'span',
            { key: "" + menu.id + index, className: itemStatus },
            _react2.default.createElement(
              'button',
              { className: "menu-item " + iconClass, onClick: function onClick(e) {
                  return !!menu.clickItem && menu.clickItem(view, viewMap);
                }, disabled: menu.hasOwnProperty('enabled') ? !menu.enabled : false },
              menu.displayTitle || menu.displayName || menu.id
            )
          );
        })
      );
    }
  }]);
  return MenuBar;
}(_baseComponent2.default)) || _class4;

function getSelectedView(currentView) {
  if (!currentView) return null;

  var lastCm = void 0,
      viewBreadcrumbs = void 0,
      insideEditor = void 0,
      currentViewOptions = {},
      currentViewProps = currentView.props || {};

  if (this) {
    lastCm = this.lastCm;
    viewBreadcrumbs = this.viewBreadcrumbs;
    insideEditor = this.insideEditor;
    currentViewOptions = this.currentViewOptions || {};
  }

  var viewOptions = (0, _assign2.default)({}, currentViewOptions, currentView.options || {});

  var itemContentModel = currentView.contentModel && currentView.contentModel.getContentModel(viewOptions);

  //take directly provided Component
  //or currentView's contentModel and run getContentModel
  var actualComponent = currentView.Component || itemContentModel && itemContentModel.getComponent(viewOptions);
  if (!actualComponent) throw new Error("missing component for view");

  return function (props) {
    return _react2.default.createElement(actualComponent, (0, _extends3.default)({
      currentView: currentView,
      options: viewOptions,
      contentModel: itemContentModel,
      // @TODO provider/inject these?
      lastCm: lastCm,
      viewBreadcrumbs: viewBreadcrumbs,
      insideEditor: insideEditor
    }, currentViewProps, props));
  };
}
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ViewControllerMixin, 'ViewControllerMixin', 'src/core_modules/layout-component/index.js');

  __REACT_HOT_LOADER__.register(Breadcrumbs, 'Breadcrumbs', 'src/core_modules/layout-component/index.js');

  __REACT_HOT_LOADER__.register(MenuBar, 'MenuBar', 'src/core_modules/layout-component/index.js');

  __REACT_HOT_LOADER__.register(getSelectedView, 'getSelectedView', 'src/core_modules/layout-component/index.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/layout-component/index.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/layout-component/index.js
// module chunks = 0